import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@workspace/frontend-ui";
import { type FC, useEffect, useMemo, useState } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import TierCard from "../TierCard";

const TierCarousel: FC = () => {
  const {
    state: { tiers, currentTier, selectedTier },
    send,
  } = useRewardCenter();
  const [api, setApi] = useState<CarouselApi>();
  const ids = useMemo(() => tiers.map((tier) => tier.id), [tiers]);
  const index = Math.max(ids.indexOf(selectedTier ?? currentTier ?? ""), 0);
  const [start] = useState(index);

  useEffect(() => {
    if (!api || api.selectedScrollSnap() === index) return;
    api.scrollTo(index);
  }, [api, index]);

  useEffect(() => {
    if (!api) return;
    const handleSelect = () => {
      const id = ids[api.selectedScrollSnap()];
      if (id) send("rewardCenter", { type: "selectTier", id });
    };
    api.on("select", handleSelect);
    return () => {
      api.off("select", handleSelect);
    };
  }, [api, ids, send]);

  if (ids.length === 0) return null;

  return (
    <Carousel
      data-slot="tier-carousel"
      opts={{ startIndex: start, align: "start" }}
      setApi={setApi}
    >
      <CarouselContent className="ml-0 items-start gap-2.5">
        {ids.map((id) => (
          <CarouselItem key={id} className="pl-0">
            <TierCard id={id} />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default TierCarousel;
